<template>
    <div class="vc-checkout-payment-methods">
        <template v-if="cart.total">
            <button :class="{'vc-checkout-payment-methods__method--selected': selectedPaymentMethod === 'paypal'}"
                    @click="onPaymentMethodSelected('paypal')"
                    class="c-button vc-checkout-payment-methods__method"
                    type="button"
                    v-if="storeAcceptPaypal">
                <img class="vc-checkout-payment-methods__method__paypal-img" src="/img/webstore/paypal.svg"
                    v-if="!paypalProcessing">
                <template v-else>
                    <font-awesome-icon class="vc-checkout-payment-methods__method__icon" icon="spinner-third"
                                    spin></font-awesome-icon>
                    Redirecting
                </template>
            </button>
            <button :class="{'vc-checkout-payment-methods__method--selected': selectedPaymentMethod === 'stripe'}"
                    :disabled="stripeProcessing" @click="onPaymentMethodSelected('stripe')"
                    class="c-button vc-checkout-payment-methods__method"
                    type="button"
                    v-if="storeAcceptStripe">
                <font-awesome-icon class="vc-checkout-payment-methods__method__icon"
                                icon="credit-card"></font-awesome-icon>
                Credit/Debit Card
            </button>
        </template>

        <template v-else>
            <button
                :class="{'vc-checkout-payment-methods__method--selected': selectedPaymentMethod === 'free'}"
                class="vc-checkout-coupon__button c-button c-button--default"
                @click="onPaymentMethodSelected('free')"
                type="button"
                :disabled="freeOrderProcessing"
                >
                <template v-if="!freeOrderProcessing">Complete Order (Free!)</template>
                <template v-else>
                    <font-awesome-icon class="vc-checkout-payment-methods__method__icon" icon="spinner-third" spin>
                    </font-awesome-icon>
                    Redirecting, Please Wait...
                </template>
                </button>
        </template>

        <input :value="selectedPaymentMethod" name="pay_method" type="hidden">
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: "checkout-payment-methods",
        data() {
            return {}
        },
        computed: {
            ...mapGetters('checkout', [
                'selectedPaymentMethod',
                'storeAcceptPaypal',
                'storeAcceptStripe',
                'paypalProcessing',
                'stripeProcessing',
                'freeOrderProcessing'
            ]),
            cart() {
                return this.$store.state.cart;
            }
        },
        methods: {
            onPaymentMethodSelected(method) {
                this.$store.dispatch('checkout/selectPaymentMethod', method);
            },
        }
    }
</script>

<style lang="scss" scoped>
    .vc-checkout-payment-methods {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
        grid-column-gap: 12px;
        grid-row-gap: 12px;

        &__method {
            font-size: 18px;
            font-weight: 500;
            color: #595E63;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-basis: 270px;
            height: 72px;
            border: 1px solid var(--input-border-color);
            background: white;
            border-radius: 5px;

            &__paypal-img {
                width: 125px;
            }

            &__icon {
                font-size: 25px;
                margin-right: 12px;
            }

            &--selected {
                border-color: var(--input-active-border-color);
                border-width: 2px;
            }

        }
    }
</style>